import React from "react";

const ClassProduct = ({ pro }) => {
  const HandlerData = KEY => {
    switch (KEY) {
      case "name":
        return {
          name: "نام کلاس",
          value: pro[KEY] != null ? pro[KEY] : "ثبت نشده است",
        };
      case "type":
        return {
          name: "نوع برگزاری",
          value: Rendertype(pro[KEY]),
        };
      case "start_date":
        return {
          name: "تاریخ برگزاری",
          value: pro[KEY] ? pro[KEY] : "ثبت نشده است",
        };
      case "price":
        return {
          name: "قیمت",
          value: pro[KEY]["second_price"]
            ? pro[KEY]["second_price"]
            : pro[KEY]["price"] + "تومان",
        };
    }
  };
  const Rendertype = type => {
    switch (type) {
      case "offline":
        return "غیر حضوری";
      case "online":
        return " حضوری";
      case "both":
        return "ترکیبی";
    }
  };
  return (
    <div style={{ marginBottom: "20px" }}>
      <div style={{ borderBottom: "1px solid red" }} className="mb-2">
        <h4 style={{ fontSize: "18px" }}>مشخصات کلاس</h4>
      </div>
      <div className="row justify-content-between px-5">
        {Object.keys(pro).map(function (value, key) {
          if (HandlerData(value))
            return (
              <div
                key={key}
                className={`col-md-6 d-flex ${
                  window.innerWidth > 600
                    ? "justify-content-start"
                    : "justify-content-between"
                }   align-items-center `}
              >
                <div>
                  <span style={{ fontWeight: "500", fontSize: "14px" }}>
                    {HandlerData(value)["name"]} :{" "}
                  </span>
                </div>
                <div>
                  <span style={{ fontWeight: "400", fontSize: "14px" }}>
                    {" "}
                    {HandlerData(value)["value"]}{" "}
                  </span>
                </div>
              </div>
            );
        })}
      </div>
    </div>
  );
};

export default ClassProduct;
